import React, { Component } from "react";
import MenuBar from "./common/MenuPanel";
import FooterPanel from "./common/FooterPanel";
import labels from "../source/labels.json";
import { Grid, Box, Typography } from "@mui/material";

class DeliveranceDetailsPage extends Component {
  render() {
    const { healing } = labels;

    return (
      <React.Fragment>
        {/* Full Width Menu */}
        <div className="container-fluid position-relative p-0">
          <MenuBar />
        </div>

        <div>
          {/* Title Section with Overlay */}
          <div className="container-fluid p-0">
            <div
              className="banner-image"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/deliveranceministry.jpg)`,
              }}
            >
              <div className="banner-heading text-center wow fadeInDown">
                <h1 className="text-white">{healing}</h1>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="container mt-4 mb-5">
            {/* First Row (Image -> Text) */}
            <Grid
              container
              spacing={4}
              alignItems="center"
              sx={{ marginBottom: 5 }}
            >
              <Grid item xs={12} md={6}>
                <img
                  className="img-fluid shadow-sm"
                  src={`${process.env.PUBLIC_URL}/images/Healing-Deliverance-Retreat-2.png`}
                  alt="Healing Deliverance Retreat"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ paddingLeft: { xs: 0, md: 3 } }}>
                  <Typography variant="body1" component="p">
                    Jesus came to this world to heal us from every illness and
                    free us from every bondage. ‘He has sent me to proclaim
                    release to the captives and recovery of sight to the blind,
                    to let the oppressed go free, to proclaim the year of the
                    Lord’s favour’ (Lk 4:18-19). The Church teaches us that
                    devil, the personification of evil is a real entity; he
                    attacks the children of God in different ways, inflicting
                    injuries in their soul, mind, and body. Any person who takes
                    up the call for preaching the good news cannot turn a blind
                    eye to the works of devil. Jesus has cast out evil spirits
                    from many persons as we read in Mk 1:21-26, Mk 5:1-13, and
                    Mk 9:14-27. While commissioning the disciples for
                    proclaiming the good news, Jesus gave them the authority to
                    cast out demons. ‘And these signs will accompany those who
                    believe: by using my name they will cast out demons….’ (Mk
                    16:17). This authority to cast out demons was passed from
                    the Apostles to their successors through the laying of
                    hands.A handful of committed Priests of the Holy Catholic
                    Church spread across the world are actively involved in this
                    vital ministry. Rev. Fr. Dominic is prominent among them.
                    All of Rev. Father’s retreats and conventions are
                    essentially Healing and Deliverance sessions. In fact the
                    major thrust of his programs are Healing and Deliverance. It
                    is no surprise that Jesus does amazing miracles through the
                    hands of his chosen servant. Here the healing hand of Jesus
                    is revealed and evil spirits run away at the very presence
                    of the Lord.
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            {/* Second Row (Text -> Image) */}
            <Grid
              container
              spacing={4}
              alignItems="center"
              sx={{ marginBottom: 5 }}
            >
              <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                <Box sx={{ paddingLeft: { xs: 0, md: 3 } }}>
                  <Typography variant="body1" component="p">
                    The healing power of Jesus continues even after twenty
                    centuries through the uninterrupted laying of hands that
                    started with the apostles. In this way the anointing given
                    to them are passed through generations. In history we can
                    see a number of saints like St. Anthony of Padua and St.
                    Benedict exercising the power to cast out demons. Healing
                    from diseases happen in a person when he comes out of sin
                    and is freed from the influence of the evil. Thousands of
                    miraculous healings happen during the sessions of Grace
                    Anointing Ministry. It is not a priest in his individual
                    capacity working miracles. A priest, exercising his power of
                    anointing in full submission to the apostolic authority of
                    the Church, is endowed with the power and authority over all
                    kinds of evil spirits that cause damages at both spiritual
                    and physical levels. Deliverance is not something new. Jesus
                    did it with his own power. Apostles did it with the power
                    delegated to them by Jesus. Paul was so gifted that ‘when
                    the handkerchiefs or aprons that had touched his skin were
                    brought to the sick, their diseases left them, and the evil
                    spirits came out of them’ (Acts 19:11). Apostles passed this
                    authority over evil spirits to their successors with the
                    laying of their hands and this uninterrupted chain of
                    conveying the anointing is what makes a priest stand against
                    the devil and cast him out. But to exercise this power over
                    evil spirits, personal holiness and an unshakeable faith in
                    the divinity of Jesus Christ is a must.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
                <img
                  className="img-fluid shadow-sm"
                  src={`${process.env.PUBLIC_URL}/images/AchanDeliverance.png`}
                  alt="Bishops"
                />
              </Grid>
            </Grid>

            {/* Third Row (Image -> Text) */}
            <Grid
              container
              spacing={4}
              alignItems="center"
              sx={{ marginBottom: 5 }}
            >
              <Grid item xs={12} md={6}>
                <img
                  className="img-fluid shadow-sm"
                  src={`${process.env.PUBLIC_URL}/images/ChristDeliverance.png`}
                  alt="Christ Deliverance"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ paddingLeft: { xs: 0, md: 3 } }}>
                  <Typography variant="body1" component="p">
                    Rev. Father Dominic Valanmanal is one among the top priests in
                    the Universal Catholic Church who has taken up exorcism and
                    deliverance ministries as his major mission. It is again
                    Grace, and Grace alone, that sustains the ministry of Rev.
                    Father Dominic and helps him recapture thousands of God’s
                    children from the precipice of hell where they were held
                    captive by the devil. All of Rev. Father’s retreats and
                    conventions are essentially Healing and Deliverance
                    sessions. The Deliverance and Healing Ministries conducts
                    Residential and Retreats and conventions across the globe.
                    Retreats are conducted in various languages. To know more
                    about the schedules, refer to the links below:
                    <br />
                    <a href="/events" rel="noopener noreferrer">
                      International Programs
                    </a>
                    <br />
                    <a
                      href="https://marianretreatcentre.org/bible-conventions/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      India Programs
                    </a>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </div>
        </div>

        <FooterPanel />
      </React.Fragment>
    );
  }
}

export default DeliveranceDetailsPage;
